export default "__VITE_ASSET__bLNX6U6f8qE7L2W0pHPLmA__ 480w, __VITE_ASSET__yQ5Mw_tp$C5jgqb_o_VSHg__ 745w";